import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useParams } from "react-router-dom";
import Banner from "../../images/banner.jpg";
import "./BlogPost.css";
import Footer from "../Footer/Footer";
import { loadBlogAnalytics } from "../../utils/loadBlogAnalytics";
import { logBlogActivity } from "../../utils/blogAnalytics";
import LikeButton from "./LikeButton";
import NavBar from "../Layout/NavBar";

const BlogPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  // Load blog with analytics merged
  useEffect(() => {
    async function load() {
      const merged = await loadBlogAnalytics(30);
      const blog = merged.find((b) => b.id === id);
      setPost(blog);
    }
    
    load();
  }, [id]);

  // Track view
  useEffect(() => {
    if (!id) return;
    logBlogActivity("view", id);
  }, [id]);

  // Real-time analytics updates (likes, views, etc)
  useEffect(() => {
    if (!id) return;

    const ref = doc(db, "blogAnalytics", id);

    const unsub = onSnapshot(ref, (snap) => {
      if (!snap.exists()) return;

      const data = snap.data();

      // Merge analytics into post without reloading everything
      setPost((prev) =>
        prev
          ? {
              ...prev,
              likes: data.likes || 0,
              views: data.views || 0,
              lastLiked: data.lastLiked || null,
              lastViewed: data.lastViewed || null,
            }
          : prev
      );
    });

    return () => unsub();
  }, [id]);


  if (!post) return <div>Loading...</div>;

  return (
    <div className="blog-post">
      <div className="shop-banner">
        <img src={Banner} alt="Shop Banner" />
      </div>

      <NavBar />

      <div className="blog-post-card">
        <h1>{post.title}</h1>

        {/* Tags + Analytics */}
        <div className="single-blog-meta-row">
          <div className="single-blog-tags">
            {post.tags?.slice(0, 3).map((tag, i) => (
              <span key={i} className="single-blog-tag">{tag}</span>
            ))}
          </div>

          <div className="single-blog-likes">
            👁️ {post.views || 0} views
          </div>
        </div>

        {/* YouTube Embed */}
        {post.embedUrl && (
          <div className="blog-embed-wrapper">
            <iframe
              src={post.embedUrl}
              title="Embedded Video"
              className="blog-embed"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        {/* Video */}
        {!post.embedUrl && post.video && (
          <video src={post.video} controls className="blog-video" />
        )}

        {/* Header Image */}
        {!post.embedUrl && !post.video && post.headerImage && (
          <img src={post.headerImage} className="blog-image" alt="" />
        )}

        {/* Body */}
        <div
          className="blog-body"
          dangerouslySetInnerHTML={{ __html: post.body }}
        />
      </div>

      <div className="single-blog-meta-row">
        <div className="single-blog-tags"></div>

        <LikeButton
          id={post.id}
          type="blog"
          initialLikes={post.likes ?? 0}
        />

      </div>

      <Footer />
    </div>
  );
};

export default BlogPost;
